import axios from 'axios';
import { ref, onMounted } from 'vue';

export default {
  name: 'CallDetailsView',
  setup() {
    const callRecords = ref([]);

    const fetchCallRecords = async () => {
      try {
        const response = await axios.get('http://51.21.2.232:8000/call_records'); 
        callRecords.value = response.data;
      } catch (error) {
        console.error('Failed to fetch call records:', error);
      }
    };

    const calculateDuration = (startTime, endTime) => {
      const start = new Date(startTime);
      const end = new Date(endTime);
      const duration = (end - start) / 60000; // duration in minutes
      return duration.toFixed(2);
    };

    onMounted(() => {
      fetchCallRecords();
    });

    return {
      callRecords,
      calculateDuration,
    };
  },
};